export const PenaltyFoulPlayer = {
  name: "penalty-foul-player",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "foul.select-player",
  showOn: [{ state: "primary", value: "penalty-foul-player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  allowBack: { value: "useHistory" },
  children: [
    {
      name: "pre-action",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      text: "",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "newEvent", value: null, type: "main" },
            { action: "clearData", value: ["scores", "success"], type: "main" },
            {
              action: "saveData",
              value: "sevenMetrePenalty",
              type: "eventType",
            },
            { action: "saveData", value: "caused", type: "subType" },
            { action: "copyEvent", value: "penalty-foul", type: "to" },
          ],
          conditions: [
            {
              item: "findInStore",
              field: "subType",
              value: "caused",
              options: ["currentPlay"],
              operator: "not",
            },
          ],
        },
        {
          actions: [
            { action: "copyEvent", value: "penalty-foul", type: "from" },
          ],
          conditions: [
            {
              item: "findInStore",
              field: "subType",
              value: "caused",
              options: ["currentPlay"],
            },
          ],
        },
      ],
    },
    {
      name: "foul-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
      },
      actionGroups: [
        {
          actions: [
            { action: "sendEvent", value: "new", type: "main" },
          ],
          conditions: [
            {
              item: "findInStore",
              field: "subType",
              value: "caused",
              options: ["currentPlay"],
              operator: "not",
            },
          ],
        },
        {
          actions: [
            { action: "clearData", value: ["flagged"], type: "main" },
            { action: "sendEvent", value: "edit", type: "main" },
          ],
          conditions: [
            {
              item: "findInStore",
              field: "subType",
              value: "caused",
              options: ["currentPlay"],
            },
          ],
        },
        {
          actions: [
            { action: "copyEvent", value: "penalty-foul", type: "to" },
            {
              action: "nextState",
              value: "penalty-suspension",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "card-buttons",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "confirm-later",
          component: "TypeButton",
          layout: "match-button",
          mode: "enable",
          text: "confirmLater",
          showOn: [true],
          startEvent: false,
          startPlay: false,
          options: {
            currentEntity: false,
          },
          actionGroups: [
            {
              actions: [
                { action: "newEvent", value: null, type: "main" },
                { action: "saveData", type: "flagged", value: true },
                {
                  action: "saveData",
                  value: "sevenMetrePenalty",
                  type: "eventType",
                },
                { action: "saveData", value: "caused", type: "subType" },
                { action: "sendEvent", value: "new", type: "main" },
              ],
              conditions: [
                {
                  item: "findInStore",
                  field: "subType",
                  value: "caused",
                  options: ["currentPlay"],
                  operator: "not",
                },
              ],
            },
            {
              actions: [
                { action: "saveData", type: "flagged", value: true },
                { action: "clearData", value: ["personId"], type: "main" },
                { action: "sendEvent", value: "edit", type: "main" },
              ],
              conditions: [
                {
                  item: "findInStore",
                  field: "subType",
                  value: "caused",
                  options: ["currentPlay"],
                },
              ],
            },
            {
              actions: [
                {
                  action: "nextState",
                  value: "penalty-suspension",
                  type: "primary",
                },
                { action: "processInserts", value: "all", type: "inserts" },
              ],
            },
          ],
        },
      ],
    },
  ],
};
